import React from 'react';
import PropTypes from 'prop-types';
import fileSaver from 'file-saver';
// APOLLO
import { graphql, compose } from 'react-apollo';
import generateComponentAsPDF from 'ApolloClient/Mutations/generateComponentAsPDF';
// ANTD
import Button from 'components/common/Button';
import message from 'antd/lib/message';
// MODULES
import PDFHelpers from 'lib/helpers/PDFHelpers';

export class DownloadPDFButton extends React.Component {
  state = {
    loading: false,
  };
  onClick = () => {
    let now = new Date();
    let params = {
      type: this.props.downloadType,
      _id: this.props.record._id,
      fileName: `document_${this.props.record._id}_${now.toISOString()}.pdf`,
    };

    this.setState({ loading: true });
    let variables = { params };

    this.props
      .generateComponentAsPDF({ variables })
      .then(({ data }) => {
        const { fileName, base64 } = data.generateComponentAsPDF;
        const blob = PDFHelpers.base64ToBlob(base64);
        fileSaver.saveAs(blob, fileName);
        message.success('PDF downloaded!', 4);
        this.setState({ loading: false });
      })
      .catch();
  };
  render() {
    const { size, buttonStyle } = this.props;

    return (
      <div style={{ textAlign: 'center' }}>
        <Button type="primary" size={size} style={buttonStyle} loading={this.state.loading} onClick={this.onClick}>
          {this.state.loading ? 'DOWNLOADING' : 'DOWNLOAD PDF'}
        </Button>
      </div>
    );
  }
}

DownloadPDFButton.propTypes = {
  downloadType: PropTypes.string,
  buttonStyle: PropTypes.object,
  record: PropTypes.object,
  size: PropTypes.string,
};

DownloadPDFButton.defaultProps = {
  downloadType: 'contract',
  record: {},
  buttonStyle: {},
  size: 'small',
};

export default compose(graphql(generateComponentAsPDF, { name: 'generateComponentAsPDF' }))(DownloadPDFButton);



// WEBPACK FOOTER //
// ./src/components/common/DownloadPDFButton/index.js